import script from "./parental.vue?vue&type=script&setup=true&lang=ts"
export * from "./parental.vue?vue&type=script&setup=true&lang=ts"

import "./parental.vue?vue&type=style&index=0&id=7f58bf49&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f58bf49"]])

export default __exports__